import React from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { DIALOG_KEYS } from "constants/dialogKeys"
import { PWA_UPDATE_AVAILABLE } from "constants/events"
import useEventListener from "hooks/useEventListener"
import { AppDispatch } from "appRedux/store"
import { useAppSelector } from "appRedux/hooks"
import { closeActiveDialogWithDelay, enqueueGlobalDialog } from "appRedux/slices/globalSlice"
import LazyImage from "components/atoms/LazyImage"
import Dialog from "components/atoms/Dialog"

export default function UpdateAvailableReminder() {
  const dialogQueue = useAppSelector((state) => state.global.globalDialog.dialogQueue)
  const activeDialog = useAppSelector((state) => state.global.globalDialog.activeDialog)

  const dispatch = useDispatch() as AppDispatch
  const { t } = useTranslation()

  useEventListener(document, PWA_UPDATE_AVAILABLE, handlePWAUpdateAvailable)

  function handlePWAUpdateAvailable() {
    console.debug("New PWA update available")
    if (!dialogQueue.includes(DIALOG_KEYS.UPDATE_AVAILABLE_REMINDER)) {
      dispatch(enqueueGlobalDialog(DIALOG_KEYS.UPDATE_AVAILABLE_REMINDER))
    }
  }

  function handleUpdate() {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration?.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" })
      }
    })
    handleCloseUpdatePWADialog()
  }

  function handleCloseUpdatePWADialog() {
    dispatch(closeActiveDialogWithDelay())
  }

  return (
    <Dialog
      message={t("general.updatePWA")}
      icon={<LogoContainer><LazyImage src="/static/images/logo/white-logo.svg" alt="logo"/></LogoContainer>}
      buttons={[
        { label: t("general.update"), mode: "white", loading: false, onClick: handleUpdate },
        { label: t("general.discard"), mode: "primary", loading: false, onClick: handleCloseUpdatePWADialog }
      ]}
      open={activeDialog === DIALOG_KEYS.UPDATE_AVAILABLE_REMINDER}
      onClose={handleCloseUpdatePWADialog}
    />
  )
}

const LogoContainer = styled(Stack)(({ theme }) => ({
  width: "64px",
  height: "64px",
  borderRadius: "50%",
  backgroundColor: theme.palette.primary["6"],
  justifyContent: "center",
  alignItems: "center",
  padding: "10px",

  "& img": {
    objectFit: "contain !important",
    transform: "translate(1px, 1px)"
  }
}))
